<template>
  <div
    class="relative h-full overflow-hidden pr-[15px]"
    v-if="!isFetchingRef && taskStore.tasksBySort.length"
  >
    <div
      v-if="false"
      :class="[
        'h-[30px] absolute',
        {
          'mask-top-bottom': showMask
        }
      ]"
    ></div>

    <TransitionGroup
      name="list"
      tag="div"
      class="flex flex-col gap-[5px] h-full pr-[10px] custom-scroll overflow-y-auto pl-[15px] py-[5px]"
    >
      <div v-for="(value, key) in taskStore.categorizedTasks" :key="key">
        <div class="flex flex-col gap-[4px]">
          <div
            @click="handleCollapse(key)"
            class="text-[12px] cursor-pointer w-full flex items-center justify-between text-[#7d7d7d] p-[8px]"
          >
            <span>{{ key }} </span>
            <el-icon :class="['icon-rotate', { 'rotate-180': collapsedMap[key] }]"
              ><i-ep-arrowDownBold
            /></el-icon>
          </div>
          <div class="flex flex-col gap-[3px]" v-show="!collapsedMap[key]">
            <div v-for="task in value" :key="task.id">
              <TaskItem :taskId="task.id" @click="handleClick"></TaskItem>
            </div>
          </div>
        </div>
      </div>
    </TransitionGroup>
    <div :class="['h-[30px] absolute mask-bottom']" v-if="false"></div>
  </div>

  <div
    class="h-full flex justify-center items-center"
    v-if="!isFetchingRef && !taskStore.tasksBySort?.length"
  >
    <el-empty :image-size="100">
      <template #description>
        <span class="text-[12px] text-[#ccc]">暂无数据</span>
      </template>
    </el-empty>
  </div>

  <div class="h-full flex justify-center items-center" v-if="isFetchingRef">
    <el-empty
      v-if="!hasDataRef && taskStore.tasksBySort?.length"
      :image-size="100"
      description="暂无数据"
    />
    <div class="flex flex-col items-center justify-center gap-[10px]" v-if="hasDataRef">
      <LoadIcon class="w-[26px] h-[26px]" />
      <p class="text-[12px] text-[#ccc]">数据加载中...</p>
    </div>
  </div>
  <el-dialog
    v-model="layoutStore.deleteDialogVisible"
    title="确认删除这 1 任务吗？"
    width="500"
    :before-close="handleClose"
    align-center
  >
    <span>删除后对话记录无法恢复和找回，请谨慎操作</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="cancelDelete"> 取消</el-button>
        <el-button @click="confirmDelete" type="danger" :loading="isDeleting"> 确定删除 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { useTaskStore } from '@/store/taskStore'
import { useLayoutStore } from '@/store/layoutStore'
import LoadIcon from './LoadIcon.vue'
import { getTasksList, taskDelete } from '@/service/task'
import { ref, reactive, onUnmounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import TaskItem from './TaskItem.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const showMask = ref(false)
const hasDataRef = ref(true)
const taskStore = useTaskStore()
const layoutStore = useLayoutStore()
const isFetchingRef = ref(true)

const collapsedMap = reactive({})
const timer = ref(null)

const popperInstance = ref(null)

const isDeleting = ref(false)

const handleCollapse = (key) => {
  collapsedMap[key] = !collapsedMap[key]
}

const handleClick = async (item) => {
  if (item.id === taskStore.currentTaskDetail.id) return // 点击的是同一条的话 则不再执行操作

  const layoutStore = useLayoutStore()
  layoutStore.showResults = false // 隐藏结果页面
  taskStore.keyWordMap[item.id] = {} // 清空当前任务的关键词
  taskStore.setCurrentTaskDetail(item) // 设置当前激活任务的详情

  layoutStore.toggleSidebar(true) // 展开侧边栏
  taskStore.initializeTaskDetail(item.id) // 初始化任务详情
}

const handleClose = () => {
  popperInstance.value?.destroy()
  if (taskStore.currentEditTask.id) {
    taskStore.currentEditTask = {}
  }
}

const confirmDelete = async () => {
  const currentTaskId = taskStore.currentTaskDetail.id
  isDeleting.value = true
  try {
    const { code } = await taskDelete(currentTaskId)
    if (code === 0) {
      taskStore.deleteTask(currentTaskId)
      ElMessage({
        message: '删除成功',
        type: 'success'
      })
    } else {
      ElMessage({
        message: '删除失败',
        type: 'error'
      })
    }
  } catch (error) {
    console.log(error)
  } finally {
    taskStore.setCurrentTaskDetail({}) // 清空当前激活任务的详情

    layoutStore.toggleSidebar(false) //关闭侧边栏
    layoutStore.showResults = false
    isDeleting.value = false
    layoutStore.setDeleteDialogVisible(false)
  }
}

const cancelDelete = () => {
  layoutStore.setDeleteDialogVisible(false)
}

const fetchTaskList = async () => {
  try {
    const { code, data } = await getTasksList()
    if (code === 0) {
      isFetchingRef.value = false
      taskStore.updateTaskList(data.list)
    }
  } catch (error) {
    ElMessage.error(error.message)
    console.error(error)
  } finally {
    isFetchingRef.value = false
  }
}

watch(
  () => route.name,
  (newRouteName) => {
    if ((newRouteName === 'Home' || newRouteName === 'Admin') && !timer.value) {
      timer.value = setInterval(() => {
        fetchTaskList()
      }, 5000)
    }

    if (newRouteName !== 'Home' && newRouteName !== 'Admin' && timer.value) {
      clearInterval(timer.value)
      timer.value = null
    }
  },
  {
    immediate: true
  }
)

onUnmounted(() => {
  clearInterval(timer.value)
})
</script>

<style lang="scss" scoped>
.mask-top-bottom {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 100), rgba(255, 255, 255, 0));
  position: absolute;
  top: 0;
  left: 0;
  right: 20px;

  z-index: 1;
}

.mask-bottom {
  background-image: linear-gradient(to top, rgba(255, 255, 255, 100), rgba(255, 255, 255, 0));
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 20px;
  z-index: 1;
}

.item-right-mask {
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.5));
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 30px;
  z-index: 1;
}

.highlight {
  background-color: #f5f4ff;
  color: #314dfb;
  position: sticky;
  top: 0;
  bottom: 0;
  z-index: 999;
  // box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.09);
}

.icon-md {
  stroke-width: 1.5;
}

.icon-md,
.icon-md-heavy {
  flex-shrink: 0;
  width: 18px;
}

.custom-scroll {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f4ff;
    border-radius: 3px;
  }
}

.rotate {
  animation: rotate 2s linear infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.icon-rotate {
  transition: transform 0.15s ease; /* 过渡时间为0.3秒，你可以根据需要调整 */
}

.rotate-180 {
  transform: rotate(180deg);
}

.tooltip-shadow {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

:deep(.el-input__wrapper) {
  box-shadow: unset;
  &:hover {
    box-shadow: unset;
  }
  .el-input__inner {
    height: 24px;
  }
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.disabled {
  cursor: not-allowed;
  opacity: 0.3;
}
</style>
